import axios from "axios";
import Vue from "vue";

export default {
  async fetchAllFirstFlowList({ commit }, payload) {
    let filter = {
      search: "",
      Language: payload.languageActiveId,
    };
    try {
      await axios
        .post(`${Vue.prototype.$baseUrl}/flowBuilder/list/0`, filter)
        .then(async (data) => {
          if (data.result === 1) {
            let list = [{ mainIntentId: 0, intentName: "Please Select" }];
            let filtered = await data.detail
              .filter(function (obj) {
                return obj.intent.length;
              })
              .map((el) => {
                return {
                  ...el,
                  visible: false,
                  intentName:
                    el.intent[payload.languageActiveId - 1].name || "",
                };
              });
            let result = list.concat(filtered);
            commit("UPDATE_ALL_FIRST_FLOW_LIST", result);
          }
        });
    } catch (error) {
      console.log(error);
    }
  },
  async fetchLogoBrand({ commit }) {
    try {
      await axios
        .get(`${Vue.prototype.$baseUrl}/system/brandlogo`)
        .then(async (data) => {
          if (data.result === 1) {
            commit("UPDATE_LOGO_BRAND", data.detail);
          }
        });
    } catch (error) {
      console.log(error);
    }
  },
  async fetchSymbolList({ commit }) {
    try {
      await axios
        .get(`${Vue.prototype.$baseUrl}/flowBuilder/condition/Symbol`)
        .then(async (data) => {
          if (data.result === 1) {
            let list = [
              {
                id: 0,
                name: "Please Select",
                isRequired: true,
                type: ["Number", "String"],
              },
            ];
            let result = list.concat(data.detail);
            commit("UPDATE_SYMBOL_LIST", result);
          }
        });
    } catch (error) {
      console.log(error);
    }
  },
  async fetchVariableList({ commit }) {
    try {
      await axios
        .get(`${Vue.prototype.$baseUrl}/System/condition/varialble`)
        .then(async (data) => {
          if (data.result === 1) {
            data.detail.forEach((element, idx) => {
              if (element.isSystemField) {
                data.detail[idx].name = element.name + " (System Type)";
              }
            });
            let list = [{ id: 0, name: "Please Select", type: "String" }];
            let result = list.concat(data.detail);
            commit("UPDATE_VARIABLE_LIST", result);
          }
        });
    } catch (error) {
      console.log(error);
    }
  },
  async fetchReplyTypeList({ commit }) {
    try {
      await axios
        .get(`${Vue.prototype.$baseUrl}/masterdata/replytype`)
        .then(async (data) => {
          if (data.result === 1) commit("UPDATE_REPLY_TYPE_LIST", data.detail);
        });
    } catch (error) {
      console.log(error);
    }
  },
  async fetchIntentTypeList({ commit }) {
    try {
      await axios
        .get(`${Vue.prototype.$baseUrl}/flowBuilder/intentType`)
        .then(async (data) => {
          if (data.result === 1) commit("UPDATE_INTENT_TYPE_LIST", data.detail);
        });
    } catch (error) {
      console.log(error);
    }
  },
  async fetchApiConfigList({ commit }) {
    try {
      await axios
        .get(`${Vue.prototype.$baseUrl}/apitrigger/all`)
        .then(async (data) => {
          if (data.result === 1) {
            let list = [{ id: 0, name: "Please Select" }];
            let result = list.concat(data.detail.data);
            commit("UPDATE_API_CONFIG_LIST", result);
          }
        });
    } catch (error) {
      console.log(error);
    }
  },
  async fetchTierMasterdataList({ commit }) {
    try {
      await axios
        .get(`${Vue.prototype.$baseUrl}/masterdata/tier`)
        .then(async (data) => {
          if (data.result === 1) {
            let list = [{ id: 0, name: "Please Select", brandId: 0 }];
            let result = list.concat(data.detail);
            commit("UPDATE_TIER_MASTER_DATA_LIST", result);
          }
        });
    } catch (error) {
      console.log(error);
    }
  },
};
